// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const deleteProjectPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  id: z.number().int().describe("Project ID"),
});

export const deleteProjectHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Project deleted
 */
export const deleteProject200Schema = z.object({});

/**
 * @description Unauthorized
 */
export const deleteProject401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

/**
 * @description Project not found
 */
export const deleteProject404Schema = z.lazy(() => v1NotFoundErrorSchema);

export const deleteProjectMutationResponseSchema = z.lazy(() => deleteProject200Schema);
